import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Global, css } from '@emotion/react';

import { CampaignsHealthStatusRenderer } from './CampaignsHealthStatusRenderer';
import { PopupProvider } from '../components/PopupProvider';
import { TapThemeProvider } from '@tapresearch/ui/components';
import { store } from '../store';
import { setTapiConfig } from '../config';

setTapiConfig();

const LazyCampaignFieldingView = lazy(
  () =>
    import(
      /* webpackChunkName: 'fieldingView' */ './CampaignFieldingViewDefault'
    )
);

const wrapContainer = (
  Component: React.ComponentType<unknown>,
  stylesOverride = true
) => {
  // eslint-disable-next-line react/display-name
  return (props: unknown) => (
    <TapThemeProvider>
      {stylesOverride && (
        <Global
          styles={css`
            body {
              font-size: 16px; // Set the font size back to the chakra default
              font-weight: 500;
            }

            .chakra-portal dd,
            .chakra-portal dt {
              line-height: inherit;
            }
            svg:not(:root) {
              overflow: inherit;
            }
          `}
        />
      )}
      <Provider store={store}>
        <PopupProvider>
          <Suspense fallback={<div></div>}>
            <Component {...props} />
          </Suspense>
        </PopupProvider>
      </Provider>
    </TapThemeProvider>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tapiContainers: Record<string, React.ComponentType<any>> = {
  CampaignFieldingView: wrapContainer(
    LazyCampaignFieldingView as React.ComponentType<unknown>
  ),
  CampaignsHealthStatusRenderer: wrapContainer(
    CampaignsHealthStatusRenderer as React.ComponentType<unknown>,
    false
  ),
};
